export const validateOrganizationForm = (name, value) => {
  switch (name) {
    case "organization_name":
      return !value.trim() ? "Organization name is required" : "";
    case "org_admin_name":
      return !value.trim() ? "Admin name is required" : "";
    case "org_admin_email":
      return !value.trim() ? "Admin email is required" : "";
    case "org_admin_contact":
      return !value.trim() ? "Admin contact is required" : "";
    case "total_hr_allocated":
      if (!value || parseInt(value) <= 0) return "HR count must be greater than 0";
      if (parseInt(value) > 10) return "HR count must not exceed 10";
      return "";
    case "timezone":
      return !value ? "Please select a timezone" : "";
    case "account_type":
      return !value ? "Please select an account type" : "";
    case "account_manager_name":
      return !value.trim() ? "Account manager name is required" : "";
    default:
      return "";
  }
};
